<div class="drawer-container" [class.opened]="showDrawer$ | async">
    <div class="ai-chat-drawer">
        <div class="ai-chat-header">
            <h4>
                <img src="./assets/img/websites/lpc-ai-chat-icon-colored.svg" />
                {{ "ai_chat_title" | translate }} <sup class="color-danger">β</sup>
            </h4>
            <div class="ai-chat-header-buttons d-flex align-items-center">
                <sp-nps-loader [isAiAssistant]="true" [pageId]="(currentPage$ | async)?.id"> </sp-nps-loader>
                <small
                    class="sp-icon icon-closed text-muted"
                    [tooltip]="'ai_chat_close_btn_tooltip' | translate"
                    [tooltipAppendToBody]="true"
                    (click)="closeDrawer()"
                >
                </small>
            </div>
        </div>
        <div class="ai-chat-body">
            <div class="ai-chat-messages">
                <div class="messages-list">
                    <div class="messages-list-container">
                        <div class="chat-message">
                            <div class="message-wrapper ai">
                                <div class="message-content">
                                    <div class="message-author">
                                        <span>{{ "ai_chat_name" | translate }}</span>
                                    </div>
                                    <div class="message-text">
                                        <span>{{ "ai_chat_default_message" | translate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        @for (message of chat.messages; track message.id) {
                            <div class="chat-message">
                                <div
                                    class="message-wrapper"
                                    [class.user]="message.role === 'user'"
                                    [class.ai]="message.role === 'assistant'"
                                >
                                    <div class="message-content">
                                        @if (message.role === "assistant") {
                                            <div class="message-author">
                                                <span>{{ "ai_chat_name" | translate }}</span>
                                            </div>
                                        }
                                        @if (messageText(message, isStreamingMessage(message, $last)); as text) {
                                            <div class="message-text">
                                                <span>{{ text }}</span>
                                            </div>
                                        }
                                        @if (message.role === "assistant" && messageToolCalls(message).length) {
                                            <div class="message-tools">
                                                @for (toolCall of messageToolCalls(message); track $index) {
                                                    <span
                                                        class="message-tool"
                                                        [class.message-tool-failed]="toolCall.failed"
                                                    >
                                                        {{ toolCall.failed ? "⚠" : "✓" }} {{ toolCall.name }}
                                                    </span>
                                                }
                                            </div>
                                        }
                                        @if (isStreamingMessage(message, $last)) {
                                            <div class="message-text btn-loading">
                                                <span
                                                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                                                >
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                        @if (showStandaloneLoader()) {
                            <div class="chat-message">
                                <div class="message-wrapper ai">
                                    <div class="message-content">
                                        <div class="message-author">
                                            <span>{{ "ai_chat_name" | translate }}</span>
                                        </div>
                                        <div class="message-text btn-loading">
                                            <span
                                                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        @if (errorMessage()) {
                            <div class="chat-message">
                                <div class="message-wrapper system">
                                    <div class="message-content alert alert-danger">
                                        <div class="message-text d-flex align-items-start">
                                            <span>{{ errorMessage() }}</span>
                                            <small
                                                class="sp-icon icon-closed ai-chat-error-dismiss"
                                                [tooltip]="'ai_chat_error_dismiss' | translate"
                                                [tooltipAppendToBody]="true"
                                                (click)="dismissError()"
                                            >
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        @if (imageUploadErrorKey()) {
                            <div class="chat-message">
                                <div class="message-wrapper system">
                                    <div class="message-content alert alert-danger">
                                        <div class="message-text d-flex align-items-start">
                                            <span>{{ imageUploadErrorKey() | translate }}</span>
                                            <small
                                                class="sp-icon icon-closed ai-chat-error-dismiss"
                                                [tooltip]="'ai_chat_error_dismiss' | translate"
                                                [tooltipAppendToBody]="true"
                                                (click)="dismissImageUploadError()"
                                            >
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div class="chat-massage-form">
                    <!--
                        The proxy's `warning` sits on the SAME line as the balance rather than in the
                        message list. Both come from one `credits` block on the last assistant reply,
                        so a warning rendered as a chat bubble hung there across turns and read as a
                        message the assistant had just sent — with the backend's raw, untranslated
                        text as its whole content ("50%").
                    -->
                    @if (creditsBalance() !== null || creditsWarning()) {
                        <p class="credits-line text-muted help-block small">
                            @if (creditsBalance() !== null) {
                                <span>Credits balance: {{ creditsBalance() }}</span>
                            }
                            @if (creditsWarning()) {
                                <span class="credits-warning">{{ creditsWarning() }}</span>
                            }
                        </p>
                    }
                    @if (attachedImageUrls().length) {
                        <div class="ai-chat-attached-images">
                            @for (url of attachedImageUrls(); track url) {
                                <div class="ai-chat-attached-image-item">
                                    <img
                                        class="ai-chat-attached-image"
                                        [src]="url"
                                        [alt]="'ai_chat_attached_image_alt' | translate"
                                    />
                                    <button
                                        type="button"
                                        class="ai-chat-attached-image-remove"
                                        [tooltip]="'ai_chat_attached_image_remove' | translate"
                                        [tooltipAppendToBody]="true"
                                        (click)="removeAttachedImage(url)"
                                    >
                                        <small class="sp-icon icon-closed"></small>
                                    </button>
                                </div>
                            }
                        </div>
                    }
                    <div class="chat-massage-textarea" [class.block-loading]="isLoading()">
                        <textarea
                            #messageInput
                            class="form-control"
                            [class.disabled]="isLoading()"
                            [formField]="chatForm.userMessage"
                            [placeholder]="'ai_chat_textarea_placeholder' | translate"
                            rows="3"
                            (keydown)="onMessageInputKeyDown($event)"
                            (paste)="onMessagePaste($event)"
                            (input)="onMessageInput($event)"
                        ></textarea>
                        @if (mentionCandidates().length) {
                            <!--
                                `mousedown.prevent` keeps the textarea from ever blurring when a row is
                                clicked — without it, blur fires before click and the selection handler
                                would run against a caret position that already moved on.
                            -->
                            <ul class="ai-chat-mention-dropdown" (mousedown)="$event.preventDefault()">
                                @for (candidate of mentionCandidates(); track candidate.id) {
                                    <li
                                        class="ai-chat-mention-item"
                                        [class.active]="candidate === activeMentionCandidate()"
                                        (click)="selectMentionCandidate(candidate)"
                                    >
                                        {{ candidate.label }}
                                    </li>
                                }
                            </ul>
                        }
                        <input
                            #screenshotInput
                            type="file"
                            class="ai-chat-screenshot-input"
                            accept="image/png,image/jpeg,image/gif,image/webp,image/avif"
                            hidden
                            (change)="onScreenshotFileSelected($event)"
                        />
                        <button
                            type="button"
                            class="btn btn-outline-secondary btn-sm ai-chat-attach-image-btn"
                            [class.disabled]="isLoading() || isUploadingImage()"
                            [class.btn-loading]="isUploadingImage()"
                            [tooltip]="'ai_chat_attach_image_btn' | translate"
                            [tooltipAppendToBody]="true"
                            (click)="triggerScreenshotPicker()"
                        >
                            <small class="sp-icon icon-attachment"></small>
                        </button>
                        <button
                            type="button"
                            class="btn btn-outline-secondary btn-sm ai-chat-pick-element-btn"
                            [class.active]="isPickingElement()"
                            [class.disabled]="isLoading()"
                            [tooltip]="
                                (isPickingElement()
                                    ? 'ai_chat_pick_element_active_tooltip'
                                    : 'ai_chat_pick_element_btn'
                                ) | translate
                            "
                            [tooltipAppendToBody]="true"
                            (click)="toggleElementPicker()"
                        >
                            <small class="sp-icon icon-pin"></small>
                        </button>
                        <button
                            class="btn btn-success btn-sm"
                            [class.disabled]="
                                (!chatForm.userMessage().value() && !attachedImageUrls().length) || isLoading()
                            "
                            (click)="onSendMessage()"
                        >
                            {{ "send" | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
